module.exports = __webpack_public_path__ + "img/what-head.1e9ae315.svg";